export default "__VITE_ASSET__7HNxpaQ9__"